import { isServer } from "./constant";
import { getAppEnv } from "./getBrowserEnv";

const MEITUAN_APP_DOWNLOAD_URL = {
  browserDownload: {
    ios: 'https://www.meituan.com/mobile/download/meituan',
    android: 'https://dd.meituan.com/appupdate/download/simple/group/64?channel=meituan',
  },
  wechatDownload: {
    ios: 'https://itunes.apple.com/app/id423084029?notitlebar=1',
    android: 'https://sj.qq.com/appdetail/com.sankuai.meituan',
  },
}

/**
 * 下载美团App
 */
export function downloadMeituanApp() {
  if (isServer) return;

  const appEnv = getAppEnv();
  if (appEnv.isIos) {
    location.href = appEnv.isWX ? MEITUAN_APP_DOWNLOAD_URL.wechatDownload.ios : MEITUAN_APP_DOWNLOAD_URL.browserDownload.ios;
  } else {
    window.open(appEnv.isWX ? MEITUAN_APP_DOWNLOAD_URL.wechatDownload.android : MEITUAN_APP_DOWNLOAD_URL.browserDownload.android);
  }
}
